import 'echarts/lib/component/radar';
import { symbols } from '../constants';
function Radar(_) {
    return null;
}
Radar[symbols.typeKey] = symbols.radar;
if (process.env.NODE_ENV !== 'production') {
    Radar.displayName = 'Radar';
}
export default Radar;
//# sourceMappingURL=Radar.js.map